import React from 'react';

const GoogleDriveIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.2 3.5c.3-.5.9-.8 1.5-.8h4.6c.6 0 1.2.3 1.5.8l5.3 9.2c.3.6.3 1.2 0 1.8l-2.3 4c-.3.6-.9.9-1.6.9H7.8c-.7 0-1.3-.4-1.6-.9l-2.3-4c-.3-.6-.3-1.2 0-1.8l4.3-7.4z"
      fill="#FFFFFF"
    />
    <path
      d="M9.6 4.6h4.8l4.9 8.5h-4.9L9.6 4.6z"
      fill="#34A853"
    />
    <path
      d="M4.8 13.1l2.4-4.1 4.8 8.3-2.4 4.1-4.8-8.3z"
      fill="#FBBC05"
    />
    <path
      d="M19.2 13.1l-4.8 8.3H7.9l4.8-8.3h6.5z"
      fill="#4285F4"
    />
    <rect x="2" y="2" width="20" height="20" rx="4" stroke="#E5E7EB" />
  </svg>
);

export default GoogleDriveIcon;

